module.exports = "https://static.im-cdn.com/mjc/storefront/Compass/static/media/Zoom.6d4ebe39.svg";